<template>
  <div class="forms">

    <a-modal v-model="modalVisible" title="选择审核结果" width="325px" centered
      @cancel="examineForm.status = 2; examineForm.reason = '';">
      <div class="change-examine">
        <a-form-model ref="ruleForm" :model="examineForm" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
          <a-form-model-item label="选择审核结果" prop="status" style="margin-bottom: 10px">
            <a-radio-group v-model="examineForm.status" name="status" :default-value="1">
              <a-radio :value="2">同意</a-radio>
              <a-radio :value="3">驳回</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div class="remark" v-if="examineForm.status == 3">
            <p style="margin-bottom: 5px"><span style="color: red;">*</span> 驳回原因</p>
            <a-input type="textarea" v-model="examineForm.reason" placeholder="请输入驳回原因" style="width: 100%"></a-input>
          </div>
        </a-form-model>
      </div>
      <div slot="footer" class="modal-footer">
        <a-popconfirm title="删除后无法恢复，是否确认删除?" ok-text="确定" cancel-text="取消" @confirm="examineConfirm"
          v-if='dislogType == "del" && examineForm.status == 2'>
          <a-button type="primary">提交</a-button>
        </a-popconfirm>
        <a-button type="primary" @click="examineConfirm" v-else>提交</a-button>
        <a-button type="primary" class="cancel"
          @click="examineForm.status = 2; examineForm.reason = ''; modalVisible = false">取消</a-button>
      </div>
    </a-modal>

    <div class="h22">
      <div class="mid">
        <a-row>
          <a-col class="flex" :span="4">
            <label>当事人：</label>
            <a-input v-model="form.debtor_realname" placeholder="请输入当事人姓名"></a-input>
          </a-col>
          <a-col class="flex" :span="6">
            <label>证件号码/代码：</label>
            <a-input v-model="form.debtor_chinaid" placeholder="请输入证件号码/代码"></a-input>
          </a-col>
          <a-col class="flex" :span="9">
            <label>发起时间：</label>
            <timePick @PickTime="PickTime" ref="timePicker"></timePick>
          </a-col>
          <a-col class="flex" :span="3">
            <label>审核状态：</label>
            <a-select v-model="form.status" placeholder="请选择" class="select">
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value="1">待审核</a-select-option>
              <a-select-option :value="2">生效</a-select-option>
              <a-select-option :value="3">驳回</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <div class="find">
          <a-button icon="search" @click="$refs.table.resh()">查询</a-button>
          <a-button @click="reset" style="margin-left: 3px;">重置</a-button>
        </div>
      </div>
    </div>
    <div class="table" v-if='load'>

      <Table :getUrl='putData.url[kType]' :formKey='putData.formKey[kType]' ID='id' ref='table' :query='q'
        :other='["debtor_id", "loan_id", "status", "action"]'>
        <template v-slot:pick='v'>
          <div class="fbtns" v-if='kType == 1' style="width:180px;">
            <div v-if='v.other[0] == 0 && v.other[1] == 0'></div>
            <div v-else>
              <div v-if='v.other[0] > 0 && v.other[1] <= 0'>
                <span v-if="$common.AUTH('debtor:info')">
                  <router-link class="curpoter" target="_blank"
                    :to='{ "name": "lydetails", params: { "id": v.other[0] }, query: { "t": 1 } }'
                    style="color: #1d8bfe;">查看</router-link>
                </span>
                <span v-else>
                  查看
                </span>
              </div>
              <div v-else>
                <span v-if="$common.AUTH('loan:info:lists')">
                  <router-link class="curpoter" target="_blank"
                    :to='{ "name": "paybacksee", params: { "id": v.other[0] }, query: { "t": 1 } }'
                    style="color: #1d8bfe;"> 查看</router-link>
                </span>
                <span v-else>
                  查看
                </span>
              </div>
            </div>
            <a href="javascript:void(0);" v-if='v.other[2] == 1' @click="examineClick(v.id, v.other[3])">审核</a>
          </div>
        </template>
      </Table>
      <!-- <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div> -->
    </div>
  </div>
</template>
<script>
import Ntxt from '@/components/textarea/ntxt'
import Table from './table.vue'
import { todoAdd, todoInfo, todoUpdate, todoOk } from '@/server/api'

import { auditCheck } from '@/server/audit'
export default {
  name: 'Infos',
  props: {
    putData: Object
  },
  data() {
    return {
      dislogType: 'add', //弹窗类型
      modalVisible: false,
      examineForm: {
        id: '',
        status: 2,
        reason: '',
      },
      load: true,
      disType: 1,
      visible: false,
      content: '',
      is_complete: 0,
      cate: 1,
      kType: 1,

      form: {
        status: 1,
        debtor_realname: '',
        debtor_chinaid: '',
        stime: '',
        etime: ''
      }
    }
  },
  components: { Ntxt, Table },
  computed: {
    top() {
      return this.$store.state.Home.Top
    },
    q() {
      switch (this.kType) {
        case 0:
          return { is_complete: this.is_complete, content: this.content }
        case 1:
          return this.form
        case 2:
          return { cate: this.cate, content: this.content }
      }
    }
  },
  methods: {
    examineClick(id, type) {
      this.dislogType = type
      this.modalVisible = true
      this.examineForm.id = id
    },

    PickTime(e) {
      if ('stime' in e) {
        this.form.stime = e.stime
      } else {
        this.form.etime = e.etime
      }
    },

    isok(id) {
      todoOk({ id: id }).then(e => {
        this.$message.success('已标记完成')
        this.$refs.table.turnpage()
      })
    },
    rest() {
      let form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        form[val] = ''
      }
      this.form = form
      this.file = {}
      this.visible = false;
    },
    examineConfirm() {
      if (!this.examineForm.reason && this.examineForm.status == 3) {
        this.$message.error('请填写驳回原因')
        return false
      }
      auditCheck(this.examineForm).then((res) => {
        this.$message.success({
          content: '审核成功'
        })
        this.examineForm.status = 2
        this.examineForm.reason = ''
        this.$refs.table.turnpage()
        this.$store.dispatch('Home/seth')//总数据获取数据 
        this.modalVisible = false
      })
    },

    async resh() {
      let p = (bool) => new Promise((resolve, reject) => {
        this.load = bool;
        resolve()
      })
      await p(false)
      await p(true)
    },
    reset() {
      this.form.debtor_realname = ''
      this.form.debtor_chinaid = ''
      this.form.stime = ''
      this.form.etime = ''
      this.form.status = ''
      this.$refs.timePicker.clearTime()
      this.resh()
    }
  }
}
</script>
<style lang="less">
.fbtns {
  display: flex;

  span {
    font-size: 0.875rem;
    color: #1d8bfe;
    display: inline-block;
    padding-right: 10px;
    position: relative;
    cursor: pointer;
    // &::after {
    //   position: absolute;
    //   right: 0;
    //   top: 4px;
    //   content: "";
    //   width: 1px;
    //   height: 14px;
    //   background: #efefef;
    //   display: block;
    // }
    // &:nth-last-child(1) {
    //   &::after {
    //     display: none;
    //   }
    // }
  }
}
</style>
<style lang="less" scoped>
.disform {
  .fintbox {
    display: flex;
    align-items: center;
    position: relative;

    .icons {
      font-size: 1.25rem;
      color: #2196f3;
      cursor: pointer;
      margin-left: 10px;
    }

    a {
      position: absolute;
      right: 34px;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 14px;
  }

  /deep/ .ipt input {
    padding-right: 50px;
  }

  .file {
    width: 200px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    position: relative;
    margin-top: 4px;

    .tit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 120px;
      overflow: hidden;
      height: 32px;
      margin-right: 2px;

      span {
        display: inline-block;
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 32px;
      }
    }

    .log {
      width: 200px;

      span {
        width: 200px;
      }
    }

    .fbox {
      position: relative;
      color: #1d8bfe;
      white-space: nowrap;

      input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}

.mid {
  display: flex;

  .flex {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-right: 10px;
  }

  .select {
    width: 90px;
  }

  .find {
    display: flex;
    align-items: center;

    /deep/.input {
      width: 132px;
      height: 30px;

      input {
        padding: 4px 8px;
        height: 30px;
        font-size: 13px;
        line-height: 30px;
      }
    }

    /deep/.ant-btn {
      height: 30px;
      margin-left: 14px;
    }
  }
}

b.err {
  color: #f00;
}
</style>